export default __webpack_public_path__ + "static/media/underConstruction.d1568cbe.svg";